/*
TRANE CONFIDENTIAL

2021 – 2022 Copyright Trane U.S. Inc.
All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of
Trane U.S. Inc. The source code, object code, intellectual and technical
concepts contained herein are proprietary to Trane U.S. Inc. and may be
covered by patents and patent applications and are protected by trade secret
and copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Trane U.S. Inc. Do not use this software without the prior written
permission of Trane U.S. Inc.
*/

import BaseCollection from "nexia_mobile/models/base_collection";
import BaseModel from "nexia_mobile/models/base_model";

export default class Account extends BaseModel {
  nestedCollections() {
    return {
      operations: {
        collection: BaseCollection,
        model: BaseModel,
      },
      contacts: {
        collection: BaseCollection,
        model: BaseModel,
      },
    };
  }

  validations() {
    return {
      firstName: {
        required: true,
      },
    };
  }

  parseLinksOperation(links) {
    let result = links.map((link) => {
      return link == null ? "" : link;
    });
    if (!result.length) {
      return;
    }
    this.get("operations").reset(result);
  }

  /* eslint-disable array-callback-return */
  /* eslint-disable consistent-return */
  parseLinksChild(links) {
    // Currently only expecting contacts so "children" really equals "contacts"
    let result = links.map((link) => {
      return link == null ? "" : link;
    });
    if (!result.length) {
      return;
    }
    const values = result[0].data;
    const href = result[0].href;
    let massagedResult = values
      .filter((contact) => {
        if (contact.email || contact.phoneNumber) {
          return contact;
        }
      })
      .map((contact) => {
        return {
          ...contact,
          _links: values._links,
          href,
        };
      });
    this.get("contacts").reset(massagedResult);
  }
}



// WEBPACK FOOTER //
// ./src/models/account.js